import React, { useEffect, useState, useRef } from "react";
import ConductJhaList from "../component/conductJhaList";
import { API_STATUS, PAGE_SIZE } from "../../../constant/constant";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as jhaAction from "../../../redux/actions/jhaAction";
import {
  ACCESS_DENIED,
  CONDUCT_JHA,
  CONDUCT_JHA_LIST,
  CONDUCT_JHA_REPORT,
} from "../../../constant/routeContant";
import { checkPrivileges } from "../../../utils/rolesHelper";
import { toast, ToastContainer } from "react-toastify";
import { InactiveClient } from "../../../utils/helper";
import Loader from "../../../library/common/Loader";
import { getCurrentRoute, getPreviousRoute } from "../../../utils/routeTracker";

function ConductJhaListContainer() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [sendEmail, setSendEmail] = useState(false);
  const [shouldRestoreState, setShouldRestoreState] = useState(false);
  const deleteTriggeredRef = useRef(false);
  const conductJhaListData = useSelector(
    (state) => state.getConductJhaListData
  );
  const deleteConductJhaData = useSelector(
    (state) => state.deleteConductJhaData
  );
  const showLoader = useSelector(
    (state) => state.deleteConductJhaData.isLoading
  );
  const NavigateAddConductjha = () => {
    if (InactiveClient()) return;
    navigate(CONDUCT_JHA);
  };
  const defaultData = {
    page: 1,
    pageSize: PAGE_SIZE,
    search: "",
    endDate: "",
    startDate: "",
    userId: 0,
    assetType: 0,
    status: "",
    isSendMail: false,
  };

  const getConductJhaList = (data) => {
    if (data?.isSendMail) {
      setSendEmail(true);
    } else {
      setSendEmail(false);
    }
    dispatch(jhaAction.getConductJhaList(data));
    dispatch(jhaAction.getConductJhaListFilterObj(data));
  };

  useEffect(() => {
    const previousRoute = getPreviousRoute();
    const preserveRoutes = [CONDUCT_JHA_LIST, CONDUCT_JHA_REPORT, CONDUCT_JHA];
    const isFromPreserveRoute =
      previousRoute &&
      preserveRoutes.some((r) => previousRoute.startsWith(r)) &&
      sessionStorage.getItem("conductJhaListPreserveState") === "true";
    sessionStorage.removeItem("conductJhaListPreserveState");

    dispatch(jhaAction.clearUpdateJha());
    dispatch(jhaAction.clearConductJha());
    if (isFromPreserveRoute && conductJhaListData?.filterObj) {
      setShouldRestoreState(true);
      getConductJhaList(conductJhaListData.filterObj);
    } else {
      setShouldRestoreState(false);
      getConductJhaList(defaultData);
    }
  }, []);
  useEffect(() => {
    if (conductJhaListData?.status === API_STATUS.SUCCESS && sendEmail) {
      toast("Conduct jha data has been sent to registered email ID");
    }
  }, [conductJhaListData]);

  const deleteConductJha = (data) => {
    deleteTriggeredRef.current = true;
    dispatch(jhaAction.deleteJhaConduct(data));
  };

  useEffect(() => {
    if (deleteConductJhaData?.status === API_STATUS.SUCCESS && deleteTriggeredRef.current) {
      deleteTriggeredRef.current = false;
      const currentFilter = conductJhaListData?.filterObj || defaultData;
      getConductJhaList(currentFilter);
    }
  }, [deleteConductJhaData]);


  return (
    <>
      {showLoader && <Loader />}
      {checkPrivileges([12, 123, 124, 125]) ? (
        <>
          <ToastContainer />
          <ConductJhaList
            getConductJhaList={getConductJhaList}
            conductJhaListData={conductJhaListData}
            NavigateAddConductjha={NavigateAddConductjha}
            isLoading={conductJhaListData.isLoading}
            deleteConductJha={deleteConductJha}
            deleteConductJhaData={deleteConductJhaData}
            sendEmail={sendEmail}
            shouldRestoreState={shouldRestoreState}
          />
        </>
      ) : (
        navigate(ACCESS_DENIED)
      )}
    </>
  );
}

export default ConductJhaListContainer;
